import './style.css';
function Cardfile({item}) {
    
    return (
        <>
            <div className="container">
                <div className="row">
                    {
                    item.map((db)=>
                    {
                        let {id,name,image,catagary,descripsion} = db
                        
                        return(
                            <div className="col-md-4">
                            <div className="card" >
                                <div className="card-header">
                                <span id="srnum">{id}</span>
                                    <h4>Name :- {name} </h4>
                                    </div>
                                <img className="card-img-top" src={image} alt="Card image cap" />
                                <div className="card-body">

                                    <h5>Catagary :- {catagary}</h5>
                                    <p>Description :- {descripsion} </p>

                                </div>
                            </div>
                        </div>
                            )  
                        
                    }
                    
                    )}
                        
                        
                            
                    </div>
                </div>

            </>
            )
                        }

            export default Cardfile;